
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companyHistoryPage",
      function () {
        return require("private-next-pages/companyHistoryPage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companyHistoryPage"])
      });
    }
  